<vivest-icon-button
  class="menu-acoes__botao"
  variant="outline"
  size="sm"
  icon="more-vertical"
  icon-source="feather"
  aria-haspopup="menu"
  [attr.aria-label]="rotulo()"
  [attr.aria-expanded]="aberto()"
  [attr.aria-controls]="aberto() ? idMenu : null"
  (click)="alternar($event)"
  data-testid="menu-acoes-botao"
></vivest-icon-button>

@if (aberto()) {
  <ul
    class="menu-acoes__lista"
    role="menu"
    [id]="idMenu"
    [attr.aria-label]="rotulo()"
    [style.top.px]="posicao().top"
    [style.bottom.px]="posicao().bottom"
    [style.right.px]="posicao().right"
    (keydown)="navegar($event)"
    data-testid="menu-acoes-lista"
  >
    @for (opcao of opcoes(); track opcao.id) {
      <li role="none" [class.menu-acoes__separada]="opcao.separada">
        <button
          type="button"
          role="menuitem"
          class="menu-acoes__item"
          [attr.aria-disabled]="opcao.desabilitada ? 'true' : null"
          [attr.title]="opcao.dica ?? null"
          [attr.data-testid]="'menu-acoes-' + opcao.id"
          (click)="selecionar(opcao)"
        >
          <vivest-icon [attr.name]="opcao.icone" source="feather" aria-hidden="true"></vivest-icon>
          {{ opcao.rotulo }}
        </button>
      </li>
    }
  </ul>
}
